export const adminToken = state => state.adminToken;
export const clientToken = state => state.clientToken;


// WEBPACK FOOTER //
// ./src/store/getters.js